import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SpaEntityStepWrapper = styled.div`
  label[class^='SliderDateField'] {
    width: 80px;
  }
  scrollbar-gutter: stable;
  @media (min-width: '600px') {
    padding: 40px 0 20px;
  }
`;

export const ExperienceWrapper = styled.div`
  width: 100%;
  padding: 30px 20px;
  display: grid;
  justify-content: center;
`;

export const GuestButtonWrapper = styled.div`
  margin-bottom: 20px;
  width: fit-content;
  button {
    width: 100%;
    padding: 15px;
  }
`;

export const GuestName = styled.div`
  margin-bottom: 20px;
`;

export const ExperienceTitleWrapper = styled.div`
  width: 100%;
  margin-top: -30px;
  padding: 0 20px;
  justify-self: center;
  justify-content: center;
  max-width: 100%;
  ${media.md`
    padding: 0;
  `}
`;

export const SpaEntitySelectionWrapper = styled.div`
  border: none;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 1rem;
  ${media.md`
    padding:  1.5rem;
    border: 1px solid #efefef;
    border-radius: 3px;
    margin-top: 8px;
    grid-template-columns: 1fr;
  `};
`;
